import { useSettings } from '../../../hooks';
export const PolicyStreamContactBroker = () => {
  const {
    settings: { email, phone },
  } = useSettings();
  return (
    <>
      {email || phone ? (
        email && !phone ? (
          <>
            {' '}
            at <EmailComponent email={email} />
          </>
        ) : !email && phone ? (
          <>
            at <PhoneComponent phone={phone} />
          </>
        ) : email && phone ? (
          <>
            at <EmailComponent email={email} /> or{' '}
            <PhoneComponent phone={phone} />
          </>
        ) : null
      ) : null}
    </>
  );
};

interface EmailComponentProps {
  email?: string | null;
}
const EmailComponent = ({ email }: EmailComponentProps) => {
  return email ? <a href={`mailto:${email}`}>{email}</a> : null;
};

interface PhoneComponentProps {
  phone?: string | null;
}
const PhoneComponent = ({ phone }: PhoneComponentProps) => {
  return phone ? <a href={`tel:${phone}`}>{phone}</a> : null;
};
